let defaultState = {
    inserted: false,
    pin: '',
    middlewareRunning: null,
    wrongPin: null,
    cardFullyRead: false,
    versions: [],
    externalPinPad: false,
    loginBusy: false,
    errorHappened: false,
    loginSuccess: false
};

const eid = (state = defaultState, action) => {
    switch (action.type) {
        case 'EID_CORRECT_CARD_INSERTED':
            return {
                ...state,
                inserted: true,
                externalPinPad: action.externalPinPad,
                loginBusy: false,
                cardFullyRead: false,
                errorHappened: false
            };
        case 'EID_CORRECT_CARD_REMOVED':
            return {
                ...state,
                inserted: false,
                wrongPin: null,
                pin: defaultState.pin,
                loginBusy: false,
                cardFullyRead: false
            };
        case 'EID_PIN_CHANGE': {
            return {
                ...state,
                pin: action.pin.replace(/\D/g,'') // digits only
            }
        }
        case 'MIDDLEWARE_OK': {
            return {
                ...state,
                middlewareRunning: true
            }
        }
        case 'MIDDLEWARE_NOT_RUNNING':
        case 'MIDDLEWARE_VERSION_TO_OLD': {
            return {
                ...state,
                inserted: false,
                middlewareRunning: false,
                versions: action.versions
            }
        }
        case 'WRONG_PIN': {
            return {
                ...state,
                wrongPin: {
                    triesLeft: action.triesLeft
                }
            }
        }
        case 'PERFORM_LOGIN': {
            return {
                ...state,
                loginBusy: true
            }
        }
        case 'LOGIN_DONE': {
            return {
                ...state,
                loginBusy: false,
                loginSuccess: true
            }
        }
        case 'EID_DATA_FULLY_READ': {
            return {
                ...state,
                cardFullyRead: true
            }
        }
        case 'EID_DATA_READ_ERROR': {
            return {
                ...state,
                loginBusy: false,
                cardFullyRead: false,
                errorHappened: true
            }
        }
        default:
            return state
    }
}

export default eid


// WEBPACK FOOTER //
// ./src/reducers/eid.js